import Io from "socket.io-client";
import _ from "lodash";
import Numeral from "numeral";
import Decimal from "decimal.js";
var throttle = require("lodash.throttle");
import Store from "../store/";
import * as Types from "../store/mutation-types";
import Api from "@/common/Api";

// _.mixin({
//   memoizeDebounce: function(func, wait = 0, options = {}) {
//     var mem = _.memoize(function(param) {
//       return _.debounce(func, wait, options);
//     });
//     return function(param) {
//       mem(param)(param);
//     };
//   },
// });

// const visibleRows = 15;
// let orderbook = {};
// let volumeSum = {};
// let currentList = {};
// let tradeList = {};

class DexkoSocket {
  init() {
    const isLocal = window.location.hostname.includes("local");
    // test
    // const SOKET_URL = `wss://ws.flybit.com/io`;
    const SOKET_URL = `wss://ws.${isLocal ? "dev." : ""}flybit.com/io`;
    const PINGPONG_INTERVAL = 30000;

    const socket = new WebSocket(SOKET_URL);

    let ping;
    const pingpong = () => {
      const sendPingPongData = { channel: "ping" };
      socket.send(JSON.stringify(sendPingPongData));
      ping = setTimeout(pingpong, PINGPONG_INTERVAL);
      console.log("pingpong");
    };

    const socketInfo = {
      channel: "eventSub",
      data: {
        events: [
          "tick",
          // "hoga",
          "krw",
          // "dominance",
          // "fear",
          // "extPrice",
          // "24h",
          // "trade",
        ],
        id: 0,
        mkidx: ["4441"], // TradeCM 구독용, 빈칸은 전체구독
        mkname: [], // TradeInit 구독용
      },
    };
    socket.addEventListener("open", function(event) {
      console.log("event------", event);
      socket.send(JSON.stringify(socketInfo));
      ping = setTimeout(pingpong, PINGPONG_INTERVAL);
    });

    socket.addEventListener("message", function(event) {
      console.log("message");
      const setSocketEvent = (lastMessage) => {
        console.log("1111111", lastMessage);
        const { event } = lastMessage;
        const { result } = lastMessage;

        console.log("22222", event);

        // if (event === "trade") {
        //   if (result.TR === "ORDER") {
        //     console.log("lastMessage.result.TR === ORDER");
        //     this.throttledUserUpdate(result.MKIDX);
        //     // receiveTradeAdd(lastMessage);
        //   } else if (result.TR === "CHE") {
        //     console.log("lastMessage.result.TR === CHE");
        //     this.throttledUserUpdate(result.MKIDX);
        //     // receiveTrade(lastMessage, true);
        //   } else if (result.TR === "CANCEL") {
        //     console.log("lastMessage.result.TR === CANCEL");
        //     this.throttledUserUpdate({ updateConcluded: true }, result.MKIDX);
        //     // receiveTrade(lastMessage, false);
        //   }
        // }

        // 24시간 거래량
        // else if (event === "24h") {
        //   console.log("24h");
        //   // receiveTradeTotal(lastMessage);
        // }
        // 가격 -> price가 tradeCM 으로 변경
        if (event === "krw") {
          console.log("krw");
          // price인지 tradeCM인지 확인차 로그 추가
          // receiveKrwPrice(lastMessage);
        }
        // 호가
        // else if (event === "hoga") {
        //   console.log("hoga");
        //   // receiveTradeInit(lastMessage);
        // }
        // 체결정보
        else if (event === "tick") {
          console.log("tick");
          const { MKIDX, PRICE, QTY } = result;
          Store.commit("UPDATE_LAST_TRADE_ROW", {
            MKIDX,
            event,
            PRICE,
            QTY,
          });
        }
        // 서버점검
        else if (event === "server") {
          console.log("server");
          location.replace("/");
          Store.commit("SET_SERVER_STATUS", false);
          Store.commit("SET_SERVER_MESSAGE", lastMessage);
          return;
          // receiveServerStatus(lastMessage);
        }
        // 새로고침
        else if (event === "refresh") {
          console.log("refresh");
          window.location.reload();
        }
        // 에러이벤트
        else if (event === "error") {
          console.log("error");
          // receiveError(lastMessage);
        }
        // 업데이트
        // else if (event === "update") {
        //   console.log("update");
        //   // receiveServiceStatus(lastMessage);
        // }
      };
      setSocketEvent(JSON.parse(event.data));
      console.log("socketEvent", event.data);
    });

    const clearPingTimeout = () => {
      if (ping) {
        clearTimeout(pingTimeout);
      }
    };

    // 서버 추가로 인한 수정
    // const { hostname } = window.location;
    // let socketTarget = "";

    // if (process.env.NODE_ENV === "development") {
    //   socketTarget = `//io.local.flybit.com`;
    //   // socketTarget = `https://io.flybit.com`;
    // } else {
    //   const isDevelop =
    //     hostname.includes("local") ||
    //     hostname.includes("dev") ||
    //     hostname.includes("localhost");
    //   if (isDevelop) {
    //     socketTarget = `https://io.dev.flybit.com`;
    //   } else if (hostname.includes("v1")) {
    //     socketTarget = `https://io.v1.flybit.com`;
    //   } else {
    //     socketTarget = `https://io.flybit.com`;
    //   }
    // }
    // socketTarget = socketTarget.replace("m.", "");

    // this.socket = Io(socketTarget);

    // const throttleDelay = 333;
    // this.throttledCommit = throttle(this.commitOrderbook, throttleDelay);
    // this.throttledUserUpdate = throttle(this.updateUserInfoFunc, throttleDelay);
    // this.throttleOrderbookSingle = throttle(
    //   this.orderbookSingle,
    //   throttleDelay
    // );
    // this.throttleUpdateCurrent = throttle(this.updateCurrent, 500);
    // this.throttleUpdateLastTradeRow = throttle(
    //   this.updateLastTradeRow,
    //   throttleDelay
    // );
    // this.throttleUpdateTradeList = throttle(
    //   this.updateTradeList,
    //   throttleDelay
    // );

    // this.socket.on("trade", (data) => {
    //   this.onTradeData(data);
    // });

    // this.socket.on("TradeAdd", ({ MKIDX }) => {
    //   this.throttledUserUpdate({ MKIDX });
    // });

    // this.socket.on("TradeCancel", ({ MKIDX }) => {
    //   this.throttledUserUpdate({ MKIDX });
    // });

    // this.socket.on("TradeComplete", ({ MKIDX }) => {
    //   this.throttledUserUpdate({ updateConcluded: true, MKIDX });
    // });

    // this.socket.on("WalletUpdate", () => {
    //   Store.dispatch("getUserWallet");
    // });

    // this.socket.on("trade:init", (data) => {
    //   const orderBookByMkidx = _.chain(data)
    //     .keyBy("MKIDX")
    //     .mapValues((orders) => {
    //       const { B, S } = orders;
    //       const fullAsk = _.chain(S)
    //         .map(({ AMOUNT_SUM, OC_PRICE, TIME }) => ({
    //           volume: AMOUNT_SUM,
    //           price: OC_PRICE,
    //           timestamp: TIME,
    //         }))
    //         .orderBy("price", "asc")
    //         .value();
    //       const fullBid = _.chain(B)
    //         .map(({ AMOUNT_SUM, OC_PRICE, TIME }) => ({
    //           volume: AMOUNT_SUM,
    //           price: OC_PRICE,
    //           timestamp: TIME,
    //         }))
    //         .value();

    //       /**
    //         15개 default로 하기 위해 뒤에다 더미데이터 넣어주기
    //       **/
    //       for (let i = 0; i < 15; i++) {
    //         fullBid.push({
    //           volume: 0,
    //           price: 0,
    //           timestamp: 0,
    //         });

    //         fullAsk.push({
    //           volume: 0,
    //           price: 0,
    //           timestamp: 0,
    //         });
    //       }

    //       /**
    //         15개 default로 하기 위해 뒤에다 더미데이터 넣어주기
    //       **/

    //       orderbook[orders.MKIDX] = {
    //         ask: fullAsk,
    //         bid: fullBid,
    //         askSum: _.reduce(
    //           fullAsk,
    //           (r, v) => {
    //             return Decimal(r)
    //               .add(v.volume)
    //               .toNumber();
    //           },
    //           0
    //         ),
    //         bidSum: _.reduce(
    //           fullBid,
    //           (r, v) => {
    //             return Decimal(r)
    //               .add(v.volume)
    //               .toNumber();
    //           },
    //           0
    //         ),
    //       };
    //       return orderbook[orders.MKIDX];
    //     })
    //     .value();

    //   this.throttledCommit();
    // });

    // this.socket.on("StateChanged", (response) => {
    //   switch (response.type) {
    //     case "server": {
    //       location.replace("/");
    //       Store.commit("SET_SERVER_STATUS", false);
    //       Store.commit("SET_SERVER_MESSAGE", response.message);
    //       break;
    //     }
    //     case "refresh": {
    //       // location.assign("/");
    //       window.location.reload();
    //       break;
    //     }
    //     case "user": {
    //       Store.dispatch("updateUserInfo");
    //       break;
    //     }
    //     case "coins": {
    //       Store.dispatch("getCoinSetting");
    //       break;
    //     }
    //   }
    // });

    // this.socket.on("rebase", (res) => {
    //   Store.dispatch("getUserWallet");
    //   Store.commit("UPDATE_REBASE_STATUS", res);
    // });

    // this.socket.on("forceRefresh", () => {
    //   window.location.reload();
    // });
  }

  // onTradeData(data, isArray = false) {
  //   //trade 데이터가 배열로 왔을 경우
  //   if (Array.isArray(data)) {
  //     //재귀로 호출하는 부분
  //     this.serializeTradeList(data);
  //     for (const trade of data) {
  //       this.onTradeData(trade, true);
  //     }
  //     this.updateTradeList();
  //     return false;
  //   }
  //   // 호가창 갱신
  //   const orders = _.get(orderbook, data.MKIDX, []);
  //   const { MKIDX, TT_PRICE: price, TT_VOLUME: volume, TIME: timestamp } = data;
  //   const TradeTypeCheck = data.OC_TYPE;
  //   const type = data.OC_TYPE === "S" ? "ask" : "bid";

  //   // 체결이 자신의 것인지 판단
  //   const midx = _.get(Store, ["getters", "User", "data", "id"], -1);

  //   switch (data.TYPE) {
  //     case "GO":
  //       // 호가 등록됨
  //       this.updateByPriceKey({ MKIDX, type, price, volume, timestamp });
  //       this.throttledCommit();
  //       break;
  //     case "CC":
  //       // 주문 취소
  //       this.updateByPriceKey({
  //         MKIDX,
  //         type,
  //         price,
  //         volume: volume * -1,
  //         timestamp,
  //       });
  //       this.throttledCommit();
  //       break;
  //     case "CM":
  //       this.updateByPriceKey({
  //         MKIDX,
  //         type,
  //         price,
  //         volume: volume * -1,
  //         timestamp,
  //       });

  //기존 한개만 업데이트 하는 코드
  // this.throttleUpdateLastTradeRow({
  //   MKIDX,
  //   type: TradeTypeCheck,
  //   price,
  //   volume
  // });
  // this.throttleUpdateTradeList();
  //       if (!isArray) {
  //         this.serializeTradeList([data]);
  //         this.updateTradeList();
  //       }

  //       // 시/종/고/저가 판단
  //       // Store.commit(Types.UPDATE_CURRENT, { MKIDX, price, volume });
  //       currentList[MKIDX] = { price, volume };

  //       const formData = {
  //         MKIDX,
  //         price,
  //       };
  //       Store.commit("SET_UPDATE_SOCKET_TICKER", formData);

  //       this.throttleUpdateCurrent();
  //       this.throttledCommit();
  //   }
  // }

  //각 마켓별로 거래내역을 모아 한번에 업데이트 합니다.
  // serializeTradeList(data) {
  //   for (const trade of data) {
  //     const sameList = data.filter((now) => {
  //       return now.MKIDX == trade.MKIDX;
  //     });
  //     const renameList = sameList.map((now) => {
  //       return {
  //         MKIDX: now.MKIDX,
  //         price: now.TT_PRICE,
  //         amount: now.TT_VOLUME,
  //         timestamp: now.TIME,
  //         type: now.OC_TYPE,
  //       };
  //     });

  //     tradeList[trade.MKIDX] = renameList;
  //   }
  // }

  // updateUserInfoFunc({ updateConcluded = false, MKIDX }) {
  //   if (updateConcluded) {
  //     Store.dispatch("updateConcluded", { marketId: MKIDX });
  //   }
  //   Store.dispatch("updatePend", { marketId: MKIDX });
  //   setTimeout(() => {
  //     return Store.dispatch("getUserWallet");
  //   }, 200);
  // }

  // get visibleOrderbook() {
  //   return _.cloneDeep(
  //     _.mapValues(orderbook, (orders) => {
  //       const ask = _.chain(orders.ask)
  //         .take(visibleRows)
  //         .map((row) => ({
  //           ...row,
  //         }))
  //         .value()
  //         .reverse();
  //       const bid = _.chain(orders.bid)
  //         .take(visibleRows)
  //         .map((row) => ({
  //           ...row,
  //         }))
  //         .orderBy("price", "desc")
  //         .value();
  //       const { askSum, bidSum } = orders;
  //       return { ask, bid, askSum, bidSum };
  //     })
  //   );
  // }

  // updateByPriceKey({ MKIDX, type, price, volume, timestamp }) {
  //   return;
  //   const sumType = type === "ask" ? "askSum" : "bidSum";
  //   const orderbookRows = _.get(orderbook, [MKIDX, type], []);

  //   // 첫 호가 등록인 경우
  //   if (orderbookRows.length === 0) {
  //     orderbookRows.push({ price, volume, timestamp });
  //   } else {
  //     for (let i = 0; i < orderbookRows.length; i++) {
  //       if (orderbookRows[i].price === price) {
  //         orderbookRows[i].volume = Decimal(orderbookRows[i].volume)
  //           .add(volume)
  //           .toNumber();
  //         if (orderbookRows[i].volume === 0) {
  //           orderbookRows.splice(i, 1);
  //         }
  //         //마이너스 예외 처리
  //         // if (orderbookRows[i].volume <= 0) {
  //         //   orderbookRows[i].volume = volume;
  //         // }
  //         break;
  //       }

  //       if (
  //         (type === "ask" && orderbookRows[i].price > price) ||
  //         (type === "bid" && orderbookRows[i].price < price)
  //       ) {
  //         orderbookRows.splice(i, 0, { price, volume, timestamp });
  //         break;
  //       }

  //       if (i === orderbookRows.length - 1) {
  //         orderbookRows.push({ price, volume, timestamp });
  //         break;
  //       }
  //     }
  //   }

  //   const absRows = orderbookRows.map((now) => {
  //     now.volume = Math.abs(now.volume);
  //     return now;
  //   });
  //   orderbook[MKIDX][type] = absRows;

  //   orderbook[MKIDX][sumType] = Decimal(orderbook[MKIDX][sumType])
  //     .add(volume)
  //     .toNumber();
  //   // this.throttledCommit(this.visibleOrderbook);
  //   // this.throttleOrderbookSingle({ id: MKIDX, data: orderbook[MKIDX] });
  // }

  // commitOrderbook() {
  //   // console.log("update");
  //   return Store.commit(Types.UPDATE_ORDERBOOK, this.visibleOrderbook);
  // }

  updateLastTradeRow({ MKIDX, type, price, volume }) {
    console.log("updateLastTradeRow-MKIDX", MKIDX);
    console.log("updateLastTradeRow-type", type);
    console.log("updateLastTradeRow-price", price);
    console.log("updateLastTradeRow-volume", volume);
    Store.commit(Types.UPDATE_LAST_TRADE_ROW, {
      MKIDX,
      type,
      price,
      volume,
    });
  }

  // updateTradeList() {
  //   Store.commit("TRADE_LOG_ARRAY", tradeList);
  //   tradeList = {};
  // }

  // updateCurrent() {
  //   // console.log("updateCurrent");
  //   Store.commit(Types.UPDATE_CURRENT, currentList);
  //   currentList = {};
  // }

  // orderbookSingle({ id, data }) {
  //   // console.log(id, data);
  //   Store.commit(Types.UPDATE_ORDERBOOK_SINGLE, { id, data });
  // }

  // 시장가 매수시 price 만큼 매수 가능한 수량 계산
  // calcMarketOrder({ marketId, buy }) {
  //   // 현재 매도 호가창 가져오기
  //   const _orderbook = _.get(orderbook, [marketId, "ask"], []);
  //   if (!_orderbook.length) {
  //     return {};
  //   }
  //   let i = 0;
  //   let result = 0;
  //   let remain = buy;
  //   let availVolume = 0;
  //   while (!result) {
  //     // 호가 전체를 긁었는지 확인
  //     if (i === _orderbook.length) {
  //       return {
  //         volume: +availVolume.toFixed(8, Decimal.ROUND_DOWN),
  //         remain,
  //       };
  //     }

  //     const { price, volume } = _orderbook[i];
  //     // 해당 호가의 전체 액수(호가 * 수량)
  //     const value = +Decimal(price).mul(volume);

  //     if (
  //       Decimal(remain)
  //         .sub(value)
  //         .toNumber() <= 0
  //     ) {
  //       // 남은 돈으로 해당 호가의 수량을 다 살 수 없는 경우 남은 돈으로 살 수 있는 수량을 계산 ( 남은 돈 / 호가 )
  //       const gettable = Decimal(remain)
  //         .div(price)
  //         .toNumber();
  //       return {
  //         volume: +Decimal(availVolume)
  //           .add(gettable)
  //           .toFixed(8, Decimal.ROUND_DOWN),
  //         remain: 0,
  //       };
  //     } else {
  //       // 남은 돈으로 해당 호가의 수량을 다 살 수 있는 경우 남은 돈에서 해당 호가의 전체 액수를 빼고, 매수 가능 수량에 해당 호가의 수량을
  //       // 더한다
  //       remain = Decimal(remain)
  //         .sub(value)
  //         .toNumber();
  //       availVolume = Decimal(availVolume)
  //         .add(volume)
  //         .toNumber();
  //     }

  //     i++;
  //   }
  // }

  // 시장가 매수시 volume만큼 구매했을 경우의 가격 계산
  //   calcMarketPriceByVolume({ marketId, buyVolume }) {
  //     // 현재 매도 호가창 가져오기
  //     const _orderbook = _.get(orderbook, [marketId, "ask"], []);
  //     let remain = buyVolume;
  //     let result = 0;
  //     for (let i = 0; i < _orderbook.length; i++) {
  //       // 호가와 수량을 가져온다
  //       const { price, volume } = _orderbook[i];
  //       // 해당 호가의 전체 액수(호가 * 수량)
  //       const value = +Decimal(price).mul(volume);

  //       if (remain >= volume) {
  //         // 해당 호가를 전부 구매 가능한 경우 남은 구매 수량에서 현재 수량을 빼고,
  //         remain = +Decimal(remain).sub(volume);
  //         // 견적에 현재 호가의 전체 액수를 더한다
  //         result = +Decimal(result).add(value);
  //       } else {
  //         // 해당 호가를 전부 구매 할 수 없는 경우 남은 구매 수량 * 호가만큼의 결과를 견적에 더하고,
  //         result = +Decimal(result).add(Decimal(price).mul(remain));
  //         // 남은 구매수량은 0이 되고 break;
  //         remain = 0;
  //         break;
  //       }
  //     }
  //     return result;
  //   }

  updateWholeData() {
    this.socket.emit("trade:init");
  }

  //   on(eventName, callback) {
  //     if (this.socket) this.socket.on(eventName, callback);
  //   }

  emit(eventName, param) {
    if (this.socket) this.socket.emit(eventName, param);
  }
  close() {
    if (this.socket) {
      // console.log(this.socket.close());
      this.socket.close();
    }
  }
}

const dexKoSocketInst = new DexkoSocket();
export default dexKoSocketInst;
